import React, { Component } from 'react';
import EnhancedTable from '../../components/table';
import Config from '../../config';
import Moment from 'react-moment';
import { Button, Toolbar, Dialog, DialogContent, Typography } from '@mui/material';
import DocType from '../../components/document_type';
import axios from 'axios';
import { getCompanyNames } from '../../helpers';
import { Link } from 'react-router-dom';
import DownloadButton from '../../components/download_button';

interface DocumentFailuresProps {
    setTitle?: (title: string) => void;
}

interface DocumentFailuresState {
    showError: boolean;
    error?: string;
    refresh?: boolean;
    tableFilter?: string;
}

class DocumentFailures extends Component<DocumentFailuresProps, DocumentFailuresState> {
    state: DocumentFailuresState = {showError: false};
    selected: Array<number | string> = [];

    componentDidMount() {
        if(this.props.setTitle) {
            this.props.setTitle('Failed Documents');
        }
    }

    onViewChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        var id = e.currentTarget.value;
        var checked = e.currentTarget.checked;
        await this.markViewed([id], checked);
        this.setState({refresh: !this.state.refresh});
    }
    exportDocuments = () => {
        let type ='xlsx';
        let url = Config.api + `/odata/Company/Functions.ExportFailedDocuments?fileType=${type}&$orderby=StatusChangeDate desc`;
        if(this.state.tableFilter){
            if(this.state.tableFilter.indexOf("(LastFailure ") > -1 || this.state.tableFilter.indexOf("(Documents ") > -1){
                this.setState({showError: true, error: "Filters on document count or last failure date cannot be applied to exports."});
                return;
            }
            url += this.state.tableFilter;
        }
        return {
            href: url,
            fileName: "failed-" + Math.floor(Date.now() / 1000).toString() + '.' + type
        };
    }
    markViewed = async (ids: Array<number | string>, viewed: boolean) => {
        await axios.get(Config.api+'/odata/Company/Functions.MarkEvents?viewed='+viewed+'&ids='+ids.join(','));
    }
    setSelected = (ids: Array<number | string>) => {this.selected = ids;}
    markSelectedViewed = async () => {
        await this.mark(true);
    }
    markSelectedUnviewed = async () => {
        await this.mark(false);
    }
    mark = async (viewed: boolean) => {
        await this.markViewed(this.selected, viewed);
        this.setState({refresh: !this.state.refresh});
    }
    onError = (error: string) => {
        this.setState({showError: true, error: error});
    }
    render(){
        var config = {
            url: Config.api + "/odata/Company/VwCompanyDocumentFailures",
            columns: [
              { id: 'PartnerCoId', filterable: false, hidden: true },
              { id: 'CompanyName', filterable: true, label: 'Sender', width: '14em', getOptions: getCompanyNames },
              { id: 'PartnerCompanyName', filterable: true, label: 'Receiver', width: '14em', getOptions: getCompanyNames },
              { id: 'DocumentType', filterable: true, label: 'Type', width: '14em', template: (value: any) => <DocType docType={value}/> },
              { id: 'Summary', filterable: true, label: 'Summary', allowStringOperators: true },
              { id: 'Documents', filterable: true, label: 'Documents', width: '8em', type: 'number' },
              { id: 'LastFailure', type:'date', filterable: true, sortable: true, label: 'Last Failure', template: (value: any) => (<Moment format='MM/DD/YYYY hh:mm A'>{value}</Moment>), width: '15em' },
              { id: 'CoId', width: '15em', stopPropagation: 'true', template: (value: any, row: any) => {return (<Button size='small' variant='outlined' component={Link} to={`/failed-documents/list?summary=${row.Summary}&sender=${row.CoId}&receiver=${row.PartnerCoId}&type=${row.DocumentType}`}>View Documents</Button>);}}
          ],
          actions: <div className="tableActions">
            <DownloadButton onError={this.onError} size='small' variant='outlined' onClick={this.exportDocuments}>Export Failed Documents</DownloadButton>
          </div>,
          order: 'desc',
          orderBy: 'LastFailure',
          keyField: row => [row.CoId, row.PartnerCoId, row.DocumentType, row.Summary, row.LastFailure].join('_'),
          pageSize: 20,
          pageSizes: [10, 20, 50, 100],
          title: 'Failed Document Summary',
          filterInUrl: true,
          refresh: this.state.refresh,
          onGetData: (builder) => this.setState({tableFilter: (builder || {}).filter}),
        }
        return (<div>
                    <EnhancedTable config={config}/>
                    <Dialog open={this.state.showError} onClose={() => {this.setState({showError: false})}}>
                        <Toolbar className='lbtoolbar'>{'Error'}</Toolbar>
                        <DialogContent><Typography>{this.state.error}</Typography></DialogContent>
                    </Dialog>
                </div>);
    }
}

export default DocumentFailures;
